import { addressFormat } from './address-format';

export const CA = {
  validator: null,
  addressFormat,
};
